<template>
	<div class="signup-popup signup-step-2">
		<form @submit.prevent="onSubmit">
			<div class="popup-wrapper">
				<div class="popup-content">
					<h1 class="popup-title text-left">Personal Details</h1>
					<p>
						<input
							type="text"
							placeholder="First name"
							required
							maxlength="100"
							v-model="formData.firstName"
						/>
					</p>
					<p>
						<input type="text" placeholder="Surname" required maxlength="100" v-model="formData.lastName" />
					</p>
					<p>
						<input
							type="text"
							placeholder="Telephone Number"
							maxlength="100"
							v-model="formData.telephone"
						/>
					</p>
					<p>
						<input type="text" placeholder="City" maxlength="100" v-model="formData.city" />
					</p>
					<p v-if="$store.state.ref && $store.state.ref.countries">
						<select v-model="formData.country">
							<option value="">Country</option>
							<option
								v-for="country in $store.state.ref.countries"
								:key="country.id"
								:value="country.id"
								:selected="country.id === formData.country"
								>{{ country.title }}</option
							>
						</select>
					</p>
					<p>
						<FileUploader
							label="Profile Picture"
							@change="onProfilePictureChange"
							:files="formData.pictureFile ? [formData.pictureFile] : []"
						/>
					</p>
				</div>
			</div>
			<div class="popup-actions">
				<a href="javascript:void(0);" class="text-button" @click="onClickBack">Back</a>
				<a href="javascript:void(0);" class="text-button" @click="onSkip">Skip</a>
				<button type="submit" class="btn btn-primary" :disabled="!isFormValid">Next</button>
			</div>
		</form>
	</div>
</template>

<script>
import FileUploader from '@/components/FileUploader';

export default {
	components: {
		FileUploader,
	},
	data() {
		return {
			formData: {
				firstName: '',
				lastName: '',
				telephone: '',
				city: '',
				country: '',
				pictureFile: undefined,
			},
		};
	},
	computed: {
		isFormValid() {
			let valid = true;
			if (
				!this.formData.firstName ||
				this.formData.firstName.trim() === '' ||
				!this.formData.lastName ||
				this.formData.lastName.trim() === ''
			)
				valid = false;

			return valid;
		},
	},
	methods: {
		onClickBack() {
			this.$emit('back');
		},
		onSubmit() {
			if (!this.isFormValid) return;

			this.formData.firstName = this.formData.firstName.trim();
			this.formData.lastName = this.formData.lastName.trim();
			this.formData.telephone = this.formData.telephone.trim();
			this.formData.city = this.formData.city.trim();
			this.formData.country = this.formData.country.trim();
			this.$store.commit('setSignupUser', this.formData);

			this.emitSubmit();
		},
		onSkip() {
			this.$emit('skip');
		},
		onProfilePictureChange(files) {
			if (files && files.length > 0) {
				this.formData.pictureFile = files[0];
			} else {
				this.formData.pictureFile = undefined;
			}
		},
		emitSubmit() {
			this.$emit('submit', this.formData);
		},
		loadFromStore() {
			this.formData.firstName = this.$store.state.signup.user.firstName || "";
			this.formData.lastName = this.$store.state.signup.user.lastName || "";
			this.formData.telephone = this.$store.state.signup.user.telephone || "";
			this.formData.city = this.$store.state.signup.user.city || "";
			this.formData.country = this.$store.state.signup.user.country || "";
			this.formData.pictureFile = this.$store.state.signup.user.pictureFile;
			console.log(this.formData);
		},
	},
	mounted() {
		this.loadFromStore();
	},
};
</script>

<style lang="scss"></style>
